import { nanoid } from "nanoid"
import stationSettings from './station-config'

const defaultSettings = {
  mainSettings: {
    protocol: 'ws',
    address: '192.168.0.149',
    port: 8002,
    chargePointId: '',
    OCPPversion: 'ocpp1.6',
    RFIDTag: nanoid(20),
    numberOfConnectors: 2,
  },

  bootNotification: {
    chargePointVendor: 'EVC',
    chargePointModel: 'EVC-Virtual1',
    chargePointSerialNumber: 'EVC-01',
    chargeBoxSerialNumber: 'A001',
    firmwareVersion: '01.00.001',
    iccid: '',
    imsi: '',
    meterType: 'ELM NQC-ACDC',
    meterSerialNumber: 'elm.001.13.1.01'
  },

  stationSettings: stationSettings.configurationKey,

  simulation: {
    diagnosticFileName: 'diagnostics.csv',
    diagnosticUploadTime: 30, // in seconds
    diagnosticStatus: 'Uploaded',
    firmWareStatus: 'Downloaded',
    connectorOneUnlock: 'Unlocked',
    connectorTwoUnlock: 'Unlocked',
  }
}

export default defaultSettings
